module.exports = __webpack_public_path__ + "img/doubleLogo.35ed73df.png";